import CTLUnReadCell from "application/components/CTLUnReadCell";
import RowAction from "application/components/RowAction";
import { actionCodeMenus } from "globals/configuration/pbxServiceMenu";

const Attributes = {
  formSize: "md",
  columns: 1,
  enableAddButton: false,
  enableAdvanceSearch: false,
  modes: actionCodeMenus.map((item) => {
        return {
          id: item.key,
          name: item.name,
          iconName: item.icon,
          url: item.url,
          description: item.description,
          disabled: item.disabled,
          productionReady: item.productionReady,
        };
      }),
  settingsMode: true,
};

const operationURLS = {
  list: "dialCodeList/list",
  update: "dialCodeList/update",
};


const getColumns = (onEdit) => {
  return [
    {
      Header: "Intercom",
      accessor: "intercom",
      displayInList: true,
      allowFilter: true,
      allowInForm: true,
      dataType: "string",
      defaultValue: "",
      Cell: ({ row, value }) => <CTLUnReadCell row={row} value={value} />,
    },
    {
      Header: "Local",
      accessor: "local",
      displayInList: true,
      allowFilter: false,
      allowInForm: true,
      dataType: "string",
      defaultValue: "",
      Cell: ({ row, value }) => <CTLUnReadCell row={row} value={value} />,
    },
    {
      Header: "STD",
      accessor: "std",
      displayInList: true,
      allowFilter: false,
      allowInForm: true,
      dataType: "string",
      defaultValue: "",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "ISD",
      accessor: "isd",
      displayInList: true,
      allowFilter: false,
      allowInForm: true,
      dataType: "string",
      defaultValue: "",
      Cell: ({ row, value }) => <CTLUnReadCell row={row} value={value} />,
    },
    {
      Header: "Action",
      accessor: "id",
      displayInList: true,
      sortDisable: true,
      Cell: ({ row, value }) => (
        <RowAction row={row} value={value} onEdit={onEdit} />
      ),
    },
  ];
};

export { getColumns, Attributes, operationURLS };
